module.exports = __webpack_public_path__ + "static/img/head2.3979f3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head2.png
// module id = Aa4G
// module chunks = 1